module.exports = __webpack_public_path__ + "static/media/BlueRightArrow.f18b04dc.svg";